import React from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "../../lib/whatsapp";

export default function AdminNotifications({ notifications, markAllRead, markRead }) {
  return (
    <div className="mt-6" data-testid="admin-notifications">
      <div className="flex items-center justify-between">
        <div className="overline">
          {notifications.unread} unread alerts
        </div>

        {notifications.unread > 0 && (
          <button
            onClick={markAllRead}
            className="text-xs underline"
            data-testid="admin-mark-all-read"
          >
            Mark all as read
          </button>
        )}
      </div>

      <div className="mt-4 space-y-3">
        {notifications.items.length === 0 && (
          <div className="text-sm text-stone-500 py-10 text-center border border-dashed border-[#E6DFD5]">
            No alerts yet. New orders and quotes will land here.
          </div>
        )}

        {notifications.items.map((n) => (
          <div
            key={n.id}
            className={`card-pmt p-4 flex flex-col sm:flex-row justify-between gap-3 ${n.unread ? "border-l-4 border-l-[#D95328]" : "opacity-70"}`}
          >
            <div>
              <div className="flex items-center gap-2">
                <span
                  className={`chip text-[10px] py-0 ${n.kind === "order" ? "bg-[#141413] text-[#FAF7F2] border-[#141413]" : ""}`}
                >
                  {n.kind}
                </span>
                <span className="font-bold text-sm">{n.title}</span>
              </div>

              <div className="text-xs text-stone-600 mt-1">{n.summary}</div>

              <div className="text-[10px] font-mono uppercase text-stone-400 mt-1">
                {new Date(n.created_at).toLocaleString()}
              </div>
            </div>

            <div className="flex items-center gap-2 flex-shrink-0">
              <a
                href={waLink(n.wa_message)}
                target="_blank"
                rel="noreferrer"
                className="btn-whatsapp text-xs"
              >
                <MessageCircle size={12} />
                Notify on WhatsApp
              </a>

              {n.unread && (
                <button
                  onClick={() => markRead(n.id)}
                  className="text-xs underline text-stone-600"
                >
                  Mark read
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
